import { usingGet, usingPost } from '@ocean/api'
import { UserUtils } from 'utils'

export const getEndUserDeclaration = () => usingGet(`Accounts/GetEndUserDeclaration`)

export const confirmEndUserDeclaration = () => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  return usingPost(`Accounts/ConfirmEndUserDeclaration`, { id: userId })
}
